import { Component, QueryList, ViewChildren } from '@angular/core';
import { NgbDate, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DevMyTitleService } from 'src/app/onelog/services/dev-my-title.service';
import { ProductListService } from 'src/app/onelog/services/product-list.service';
import { ProductSatusService } from 'src/app/onelog/services/product-status.service';
import { ProductService } from 'src/app/onelog/services/product.service';
import { SachLoginService } from 'src/app/onelog/services/sach-login.service';
import { environment } from 'src/environments/environment';
import { saveAs } from 'file-saver';
import * as FileSaver from 'file-saver';
import { HttpClient } from '@angular/common/http';
import { AclService } from 'src/app/onelog/services/acl.service';
import { Router } from '@angular/router';
import { DEV_MY_TITLE_URL } from 'src/app/onelog/common/config/url';
import { PAGE_SIZE, MAX_SIZE } from 'src/app/onelog/common/config/common';
import {
  DROP_DOWN_LIST_PRODUCT_TYPE,
  DROP_DOWN_SETTING_PRODDUCT_TYPE,
  DROP_DOWN_LIST_BOOK_TYPE,
  DROP_DOWN_SETTING_BOOKTYPE,
  SELECT_TYPE_DROP_DOWN_OPTIONS,
  SELECT_STATUS_TYPE_DROP_DOWN_OPTIONS,
  DEFAULT_SELECTED_STATUS,
  SELECT_USER_ID_TYPE_DROP_DOWN_OPTIONS
} from 'src/app/onelog/common/config/dropdown-config';

import { CommonModule } from '@angular/common';
import { DropDownSingleSelectComponent } from 'src/app/onelog/common/fields/drop-down-single-select/drop-down-single-select.component';
import { CustomEvents } from 'src/app/onelog/classes/CustomEvent';
import { DateSelectComponent } from 'src/app/onelog/common/fields/date-select/date-select.component';


@Component({
  selector: 'app-dev-my-title',
  templateUrl: './dev-my-title.component.html',
  styleUrls: ['./dev-my-title.component.css'],
})
export class DevMyTitleComponent {
  Products: any = [];
  ProductStatusList: any = [];
  selectedProduct: any = [];
  selectedStatus: string = '';
  dropdownListProductType: any = [];
  dropdownSettingsProductType: IDropdownSettings = {};
  dropdownListBookType: any = [];
  dropdownSettingsBookType: IDropdownSettings = {};
  selectedProductType: any = [];
  selectedBookType: any = [];
  selectedproductId: string = '';
  receivedDate: NgbDate;
  apiURL = environment.sachWebURL;
  responseData: any = [];
  //showLoader: boolean = false;
  totalProducts: number = 0;
  perPage: number = 0;
  lastPage: number = 0;
  currentPage: number = 0;
  selectedPPD: string = '';

  selectTypeDropDownOptions: any = SELECT_TYPE_DROP_DOWN_OPTIONS;

  selectStatusTypeDropDownOptions: any = SELECT_STATUS_TYPE_DROP_DOWN_OPTIONS;

  ppdSelectedFilterData: any = [];
  publishedDateSelectedFilterData: any = [];

  dropdownListBookStatus: any = [];
  selectedStatusType: any = [];
  selectedStatusFilterType: string = '';
  selectedStatusFilter: any = [];
  searchBtnText = 'Search';
  showSearchLoading = false;
  downloadBtnText = 'Download';
  showDownloadLoading = false;

  selectedUserIDFilterType: string = 'current user';
  selectedUserIDFilterData: any = [];
  selectedUserId: string = '';
  publisherList: any = [];
  dropdownPublisherList: any = [];
  selectedPublisher: any = [];

  selectedDefaultItemsStatus: any = [];
  DefaultselectedOptionType: string = 'not in';
  pageSize: number = PAGE_SIZE;
  maxSize: number = MAX_SIZE;

  dropdownListUserId : Array<string> = [];
  disableUserIdField : Boolean = true;
  clearFilterIgnoreList : Array<string> = [ 'status']
  selectedDefaultUserId : string = 'current user';

  @ViewChildren(DropDownSingleSelectComponent)
  DropDownSingleSelectComponent: QueryList<DropDownSingleSelectComponent>;

  @ViewChildren(DateSelectComponent) NgbDate: QueryList<DateSelectComponent>;

  //showLoader : boolean = false;

  constructor(
    private productService: ProductService,
    private productStatus: ProductSatusService,
    private sachLoginService: SachLoginService,
    private productListService: ProductListService,
    private modalService: NgbModal,
    private devMyTitleService: DevMyTitleService,
    private aclService: AclService,
    private router: Router
  ) {}




  ngOnInit() {
    this.aclService.checkAccess(this.router.url);

    this.selectedStatusFilterType = 'not in';

    this.dropdownListProductType = DROP_DOWN_LIST_PRODUCT_TYPE;
    this.dropdownSettingsProductType = DROP_DOWN_SETTING_PRODDUCT_TYPE;

    this.dropdownListBookType = DROP_DOWN_LIST_BOOK_TYPE;

    this.dropdownSettingsBookType = DROP_DOWN_SETTING_BOOKTYPE;

    this.dropdownListUserId = SELECT_USER_ID_TYPE_DROP_DOWN_OPTIONS;
   
    this.loadProductStatusList();

    this.loadPublishers();
  }


  loadProductStatusList() {
   
    return this.productStatus.getStatusList().subscribe((data: {}) => {
      this.ProductStatusList = data;
      let statusList: any = [];
      let selectedStatusList: any = [];
      let defaultStatusList: any = DEFAULT_SELECTED_STATUS;
      let tempSelectedDd: any = [];
      this.ProductStatusList.data.forEach(function (
        currentValue: any,
        index: any,
        arr: any
      ) {
        let obj: any = {};
        obj['item_id'] = currentValue.attributes.name;
        obj['item_text'] = currentValue.attributes.name;
        statusList.push(obj);
        //statusList = '';
        

        if (defaultStatusList.includes(currentValue.attributes.name)) {
          selectedStatusList.push(obj);
          tempSelectedDd.push(currentValue.attributes.name);
        }
      });
      
      this.dropdownListBookStatus = statusList;
     
      this.selectedDefaultItemsStatus = selectedStatusList;
      this.selectedStatusType = tempSelectedDd;

      this.loadProducts(this.createPostData());
     
    });
  }

  updateStatus(event: any) {
    const data = event;
    const selectedId = data.selectedStatusId;
    this.receivedDate = event;
  }

  updateIepd(event: NgbDate) {
    this.receivedDate = event;
  }

  searchProduct() {
    this.searchBtnText = 'Searching...';
    this.showSearchLoading = true;

    

    this.setStatusFilterData();

    this.loadProducts(this.createPostData());
  }

  // Get product list
  loadProducts(postdata: any = [], getdata: string = '') {
   
    return this.devMyTitleService
      .getProducts(postdata, getdata)
      .subscribe((data: {}) => {
        this.responseData = data;
        //this.Products = this.responseData.data;
        this.Products = this.responseData.data;
        this.totalProducts = this.responseData.total;
        this.perPage = this.responseData.per_page;
        this.lastPage = this.responseData.last_page;
        this.currentPage = this.responseData.current_page;
        

        this.searchBtnText = 'Search';
        this.showSearchLoading = false;

        
      });
  }

  updateSelectedDropDown(event: Event) {
    const data: any = event;
    if (data.type == 'productType') {
      if (data.action == 'selected') {
        this.selectedProductType.push(data.item.item_text);
      } else {
        const index = this.selectedProductType.indexOf(data.item.item_text);
        this.selectedProductType.splice(index, 1);
      }
    }

    if (data.type == 'bookType') {
      if (data.action == 'selected') {
        this.selectedBookType.push(data.item.item_text);
      } else {
        const index = this.selectedBookType.indexOf(data.item.item_text);
        this.selectedBookType.splice(index, 1);
      }
    }

    if (data.type == 'bookStatus') {
      if (data.action == 'selected') {
        this.selectedStatusType.push(data.item.item_text);
      } else {
        const index = this.selectedStatusType.indexOf(data.item.item_text);
        this.selectedStatusType.splice(index, 1);
      }
    }

    if (data.type == 'publisher') {
      if (data.action == 'selected') {
        this.selectedPublisher.push(data.item.item_id);
      } else {
        const index = this.selectedPublisher.indexOf(data.item.item_id);
        this.selectedPublisher.splice(index, 1);
      }
    }

    
  }

  updatePageData(event: Event) {
    let eventData: any = event;
    
    let urlParams = '?page=' + eventData.currentPage;
    this.loadProducts(this.createPostData(), urlParams);
  }

  downloadReport() {
    let urlParams = '?is_download=1';

    this.setStatusFilterData();

    this.devMyTitleService.download(
      {
        is_download: 1,
        selectedBookType: this.selectedBookType,
        selectedProductType: this.selectedProductType,
        selectedproductId: this.selectedproductId,
        //selectedPPD: this.ppdSelectedFilterData,
        selectedPPD: Object.assign({}, this.ppdSelectedFilterData),
        selectedPublishedDate: Object.assign(
          {},
          this.publishedDateSelectedFilterData
        ),
        selectedStatus: Object.assign({}, this.selectedStatusFilter),
        selectedUserID: Object.assign({}, this.selectedUserIDFilterData),
        selectedPublisher: this.selectedPublisher,
      },
      '',
      DEV_MY_TITLE_URL
    );
   
  }

  updateSelectedIepd(event: any) {
    
    this.selectedPPD = event.dateString;

    if (event.type == 'ppd') {
      this.ppdSelectedFilterData['date'] = event.dateString;
    }

    if (event.type == 'publishedDate') {
      this.publishedDateSelectedFilterData['date'] = event.dateString;
    }
  }

  updateSelectedType(event: any) {
    

    if (event.name == 'ppd') {
      this.ppdSelectedFilterData['selectedFilterType'] = event.selectedOption;
    }

    if (event.name == 'publishedDate') {
      this.publishedDateSelectedFilterData['selectedFilterType'] =
        event.selectedOption;
    }

    if (event.name == 'status') {
      this.selectedStatusFilterType = event.selectedOption;
    }

    if (event.name == 'userId') {
      this.selectedUserIDFilterType = event.selectedOption;

      if(this.selectedUserIDFilterType == 'current user' || this.selectedUserIDFilterType == 'ignore'){
         this.disableUserIdField = true;
      }else{
        this.disableUserIdField = false;
      }

    }


    
  }

  setStatusFilterData() {
    if (
      this.selectedStatusFilterType !== null &&
      this.selectedStatusType.length > 0
    ) {
      this.selectedStatusFilter['selectedFilterType'] =
        this.selectedStatusFilterType;
      this.selectedStatusFilter['selected'] = this.selectedStatusType;
    }

    if (
      this.selectedUserIDFilterType !== null &&
      this.selectedUserIDFilterType !== ''
    ) {
      this.selectedUserIDFilterData['UserId'] = this.selectedUserId;
      this.selectedUserIDFilterData['selectedFilterType'] =
        this.selectedUserIDFilterType;
    }

    
  }

  createPostData() {
    this.setStatusFilterData();

    return {
      selectedBookType: this.selectedBookType,
      selectedProductType: this.selectedProductType,
      selectedproductId: this.selectedproductId,
      selectedPPD: Object.assign({}, this.ppdSelectedFilterData),
      selectedPublishedDate: Object.assign(
        {},
        this.publishedDateSelectedFilterData
      ),
      selectedStatus: Object.assign({}, this.selectedStatusFilter),
      selectedUserID: Object.assign({}, this.selectedUserIDFilterData),
      selectedPublisher: this.selectedPublisher,
    };
  }

  loadPublishers() {
    return this.devMyTitleService.getPublisherUsers().subscribe((data: {}) => {
      this.publisherList = data;
      let statusList: any = [];
      
      this.publisherList.forEach(function (
        currentValue: any,
        index: any,
        arr: any
      ) {
        let obj: any = {};
        obj['item_id'] = currentValue.id;
        obj['item_text'] = currentValue.first_name;
        statusList.push(obj);
        
      });
      
      this.dropdownPublisherList = statusList;
     
    });
  }

  clearFilters(){

    this.clearAllSingleDropDown()
    this.clearAllDates();
    this.clearProductIdInput();
  }

  clearAllSingleDropDown(){
    this.DropDownSingleSelectComponent.forEach((DropDownComp) => {
      this.clearFilterIgnoreList.includes(DropDownComp.name ) ? "" : DropDownComp.clearInput();
    });
  }

  clearAllDates(): void {
    this.NgbDate.forEach((datePickerComp) => {
      datePickerComp.clearDate();
    });
  }

  resetDropDownVal(event : CustomEvents){
    if(event.name == 'userId'){
      this.setDefaultValues('userId')
    }

  }

  setDefaultValues(fieldName : string){

    this.DropDownSingleSelectComponent.forEach((DropDownComp) => {
      if(DropDownComp.name == fieldName){
        DropDownComp.setSelected(this.selectedDefaultUserId);
      }
    });

  }

  resetDateVal(event : CustomEvents){
    if(event.type == 'ppd'){
      this.ppdSelectedFilterData = [];
    }

    if(event.type == 'publishedDate'){
      this.publishedDateSelectedFilterData = [];
    }
   
    
  }

  clearProductIdInput(){
    this.selectedproductId = '';
  }
}
